export default __webpack_public_path__ + "static/media/icon_toc_pp.dddbe08b.svg";